import React from "react";
import {
  isInvoiceFullyPaid,
  isInvoicePastDue,
  isInvoiceWrittenOff,
  isInvoicePartiallyPaid,
  isInvoiceRefunded,
} from "components/invoicing/utils/invoiceStatus";
import getClasses from "utils/getClasses";
import styles from "./InvoicingTag.module.scss";

const InvoicingTag = ({ invoice }) => {
  if (isInvoiceFullyPaid(invoice)) {
    return (
      <span
        className={getClasses(
          styles["invoicing-tag"],
          styles["invoicing-tag--paid"],
        )}
      >
        PAID
      </span>
    );
  } else if (isInvoicePartiallyPaid(invoice)) {
    return (
      <span
        className={getClasses(
          styles["invoicing-tag"],
          styles["invoicing-tag--partial"],
        )}
      >
        PARTIAL
      </span>
    );
  } else if (isInvoicePastDue(invoice)) {
    return (
      <span
        className={getClasses(
          styles["invoicing-tag"],
          styles["invoicing-tag--past-due"],
        )}
      >
        PAST DUE
      </span>
    );
  } else if (isInvoiceWrittenOff(invoice)) {
    return (
      <span
        className={getClasses(
          styles["invoicing-tag"],
          styles["invoicing-tag--write-off"],
        )}
      >
        WRITE-OFF
      </span>
    );
  } else if (isInvoiceRefunded(invoice)) {
    return (
      <span
        className={getClasses(
          styles["invoicing-tag"],
          styles["invoicing-tag--refunded"],
        )}
      >
        REFUNDED
      </span>
    );
  } else {
    return (
      <span
        className={getClasses(
          styles["invoicing-tag"],
          styles["invoicing-tag--unpaid"],
        )}
      >
        UNPAID
      </span>
    );
  }
};

export default InvoicingTag;
